<template>
  <div>
    <el-row :gutter="20" style="margin: 10px 0;">
      <el-col :span="24" :offset="0">
        <el-switch v-model="checked" style="margin-right: 20px;" active-text="Remove (.00) Rounding"></el-switch>
        <el-switch v-model="test" @change="toggleAll" active-text="Expand Transactions"></el-switch>
      </el-col>
    </el-row>


    <el-table
      ref="table"
      :data="data"
      row-key="id"
      max-height="650"
      size="small"
      :row-class-name="tableRowClassName"
      @cell-click="cellClick"
      :empty-text="$t('general_noData')"
      style="width: 100%">
      <el-table-column
        fixed
        sortable
        width="150"
        :label="$t('settings_transactionNo')">
        <template slot-scope="scope">
          <strong @click="cellClickID(scope.row)" style="color: #409EFF; cursor: pointer;">{{scope.row.transactionNo}}</strong>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        width="120"
        sortable
        prop="transactionDate"
        :label="$t('settings_transactionDate')">
      </el-table-column>
      <el-table-column
        width="180"
        prop="transactionCode"
        :label="$t('settings_transactionCode')">
      </el-table-column>
      <el-table-column
        width="180"
        prop="transactionType"
        :label="$t('settings_transactionType')">
      </el-table-column>
      <el-table-column
        width="120"
        prop="status"
        sortable
        label="Status"
        align="center">
      </el-table-column>
      <el-table-column
        width="120"
        sortable
        label="History"
        align="center">
        <template slot-scope="scope">
          <div v-if="!scope.row.isParent" @click="cellClickStatus(scope.row)" style="display: flex; justify-content: center; align-items: center; cursor: pointer;">
            <img src="@/assets/img/history.png" alt="History" height="24px">
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        width="150"
        prop="creatorName"
        :label="$t('settings_name')">
      </el-table-column> -->
      <el-table-column
        width="150"
        align="center"
        prop="details"
        :label="$t('settings_transactionDescription')">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.details"
            placement="top"
            title="Details"
            width="400"
            trigger="click"
            :content="scope.row.details">
            <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        prop="account"
        :label="$t('settings_account')">
        <template slot-scope="scope">
          <div style="word-break: normal;">{{ scope.row.account }}</div>
        </template>
      </el-table-column>
      <el-table-column
        width="140"
        align="right"
        :label="$t('settings_debit')">
        <template slot-scope="scope">
          <div v-if="!scope.row.isParent">
            <div v-if="checked">{{ scope.row.debit > 0 ? formatPriceLong(scope.row.debit) : null }}</div>
            <div v-else>{{ scope.row.debit > 0 ? formatPrice(scope.row.debit) : null }}</div>
          </div>
          <div v-else style="font-weight: bold;" :style="{ color: +scope.row.debit !== +scope.row.credit ? 'red' : '' }">
            <div v-if="checked">{{ scope.row.debit > 0 ? formatPriceLong(scope.row.debit) : null }}</div>
            <div v-else>{{ scope.row.debit > 0 ? formatPrice(scope.row.debit) : null }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="140"
        align="right"
        :label="$t('settings_credit')">
        <template slot-scope="scope">
          <div v-if="!scope.row.isParent">
            <div v-if="checked">{{ scope.row.credit > 0 ? formatPriceLong(scope.row.credit) : null }}</div>
            <div v-else>{{ scope.row.credit > 0 ? formatPrice(scope.row.credit) : null }}</div>
          </div>
          <div v-else style="font-weight: bold;" :style="{ color: +scope.row.debit !== +scope.row.credit ? 'red' : '' }">
            <div v-if="checked">{{ scope.row.credit > 0 ? formatPriceLong(scope.row.credit) : null }}</div>
            <div v-else>{{ scope.row.credit > 0 ? formatPrice(scope.row.credit) : null }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="140"
        align="center"
        header-align="center"
        prop="transactionCurrency"
        label="Home Currency">
      </el-table-column>
      <el-table-column
        width="140"
        sortable
        align="right"
        :label="$t('settings_amount')">
        <template slot-scope="scope">
          {{ scope.row.amount > 0 ? formatPrice(scope.row.amount) : null }}
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        align="center"
        header-align="center"
        label="Transaction Currency">
        <template slot-scope="scope">
          {{ scope.row.foreignCurrency !== 'null' ? scope.row.foreignCurrency : null }}
        </template>
      </el-table-column>
      <el-table-column
        width="140"
        sortable
        align="right"
        label="Transaction">
        <template slot-scope="scope">
          {{ scope.row.foreignamount > 0 ? formatPrice(scope.row.foreignamount) : null }}
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        prop="isLocated"
        :label="$t('settings_isLocated')">
      </el-table-column>
      <el-table-column
        width="150"
        prop="vendorName"
        :label="$t('settings_vendorId')">
      </el-table-column>
      <el-table-column
        width="150"
        prop="clientName"
        :label="$t('settings_clientId')">
      </el-table-column>
    </el-table>

    <editJournalEntryModal @updateList="getList" :showInfo="false" ref="editJournalEntryModal"/>

    <!-- Modal History -->
    <modal-history :historyList='historyList' ref="openHistory"></modal-history>

  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'
import modalHistory from '../journalAndGl/historyJournalEntry.vue'

export default {
  name: "journalReport",
  props: {
    transactionId: {
      default: null
    }
  },
  components: {
    editJournalEntryModal,
    modalHistory
  },
  data() {
    return {
      checked: false,
      test: false,
      moment: moment,
      data: [],
      page: 1,
      total: 0,

      historyList: [],
    }
  },
  created () {

  },
  methods: {
    toggleAll() {
      this.data.forEach(row => {
        this.$refs.table.toggleRowExpansion(row, this.test);
      });
    },
    getList() {
      this.item()
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    formatPriceLong(value, fixed) {
      let parts = value.toString().split(".")
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      return parts.join(".")
    },
    openModal() {
      this.item()
    },
    tableRowClassName({row, rowIndex}) {
      if (row.isParent) return 'header-bg'
    },
    item(filterBy = null, filterValue = null) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/account/company-ledger/report?companyId=${this.$route.query.companyId}&filterBy=${filterBy}&filterValue=${filterValue}`)
          .then(response => {
            this.data = response.data.report
            let id = 1
            this.data.forEach((item) => {
              item.id = id
              id++
              item.children.forEach((item) => {
                item.id = id
                id++
                item.transactionDate = item.transactionDate ? moment(item.transactionDate).format("D MMM YYYY") : ''
                item.amount = (+item.debit + +item.credit)
              })
            })
            if (this.transactionId) {
              const row = this.data.find(val => val.id == this.transactionId)
              if (row) this.cellClickID(row)
              this.$emit('resetTransition')
            }
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    cellClick(row, column, cell, event){
    },
    cellClickID(row){
      let rowItem = row
      rowItem.id = rowItem.transactionid
      this.$refs['editJournalEntryModal'].openModalFromJournalEntry(rowItem)
    },
    cellClickStatus(row) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/accountTransaction/journal-history?companyId=${this.$route.query.companyId}&transactionId=${row.transactionid}`)
        .then(response => {
          this.$refs.openHistory.openModal()
          this.historyList = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-table .header-bg {
  background: #F5F7FA;
}
</style>
